import {createContext} from "react";

// set the defaults
const LanguageContext = createContext("LV");

export default LanguageContext;
